import {
	emailValidator,
	floatNumValidator,
	passwordValidator,
	validateNumber,
	validatePhone,
	validatePositiveNumber,
	validateUrl,
	validateBIK,
	validateInn,
	validateKbk,
	validateOkpo,
	validateOktmo,
	validatePaymentAccount,
	validateSnils,
	internationalOrgNameValidate,
	intOrgShortNameValidate,
	orgNameValidate,
	orgShortNameValidate,
	validatePassport,
	validatePassportNumberRedux,
	validatePassportSeriesRedux,
} from 'Modules'

export const simpleValidators = {
	email: emailValidator,
	email_2: emailValidator,
	email_extra: emailValidator,
	email_2_extra: emailValidator,
	email_for_docs: emailValidator,
	manager_email: emailValidator,
	finance_person_email: emailValidator,
	phone: validatePhone,
	contact_phone: validatePhone,
	sber_online_phone: validatePhone,
	phone_2: validatePhone,
	phone_extra: validatePhone,
	phone_2_extra: validatePhone,
	manager_phone: validatePhone,
	questions_contact_phone: validatePhone,
	oktmo: validateOktmo,
	okpo: validateOkpo,
	kbk: validateKbk,
	payment_account: validatePaymentAccount,
	account_number: validatePaymentAccount,
	operation_average_sum: floatNumValidator,
	equip_amount: validateNumber,
	turn_over: floatNumValidator,
	account_bank_bic: validateBIK,
	snils: validateSnils,
	inn: validateInn,
	series: validatePassportSeriesRedux,
	number: validatePassportNumberRedux,
	passport_series: validatePassportSeriesRedux,
	passport_number: validatePassportNumberRedux,
	passport: validatePassport,
	org_name: orgNameValidate,
	international_org_name: internationalOrgNameValidate,
	org_short_name: orgShortNameValidate,
	international_org_short_name: intOrgShortNameValidate,
	rate: validatePositiveNumber,
	site: validateUrl,
	password: passwordValidator,
}

export const simpleValidatorsOptions = {
	rate: {
		payload: {
			min: 1.6,
			max: 2.5,
		},
	},
}
